// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".homestay__item .card-horizontal__user-photo span{background:#2e76e4}", ""]);
// Exports
module.exports = exports;
